import { hourFormat, dateFormat } from "../../../functions/functions";
import "./liveGamesCard.sass";

export default function LiveGamesCard({ imagen, titulo, horaInicio, enlace, tipo }) {

  // Funcion para obtener la extension de la URL
  const obtenerExtension = (url) => {
    // Obtiene el ultimo segmento de la URL despues de la ultima barra '/'
    let filename = url.substring(url.lastIndexOf('/') + 1);
    // Obtiene la extensión del archivo
    let extension = filename.substring(filename.lastIndexOf('.') + 1);

    return extension;
  };

  // Llama a la funcion para obtener la extensión dinamicamente
  let extension = obtenerExtension(imagen);
  let regex = new RegExp(`\\.${extension}$`, 'i'); // 'i' la búsqueda sera insensible a mayusculas/minusculas
  let newUrl = imagen.replace(regex, '');

  return (
    <a className={"container-card-partidos-envivo borderLight"} href={enlace} target={"_top"} rel="noreferrer">

      <div className="seccion-img-partidos">
        {tipo === 'video' && <i className="AMX-icon-play"></i>}
        <img
          loading="lazy"
          decoding="async"
          src={imagen}
          className={"imagen-portada"}
          alt={titulo}
          srcSet={`${newUrl}-768x432.${extension} 768w, ${newUrl}-300x169.${extension} 300w, ${newUrl}-1024x576.${extension} 1024w, ${imagen} 1200w`}
          sizes="(max-width: 768px) 100vw, 768px"
        />
      </div>

      <div className="seccion-contenido-partidos">
        <h3 className={"contenido-resumen"}>{titulo}</h3>

        <div className="contenido-date">
          <time dateTime={horaInicio} className="hour paddingR5">{dateFormat(horaInicio)}, {hourFormat(horaInicio)} hrs</time>
        </div>
      </div>
    </a>
  )
}